var map = {
	"./amazonevent.jpeg": 238,
	"./bestbuddynusopenhouseday.jpeg": 239,
	"./demodaywithpresident.jpeg": 240,
	"./favcafeatnus.jpeg": 241,
	"./friendsnus.jpeg": 242,
	"./fullhousessi.jpeg": 243,
	"./goodfriends.jpeg": 244,
	"./haroldstenurecelebration.jpeg": 245,
	"./haroldstenurecelebration2.jpeg": 246,
	"./haroldtenure.jpeg": 247,
	"./havingfundaticra24.jpeg": 248,
	"./icra24friendsanddad.jpeg": 249,
	"./icra24haroldspeech.jpeg": 250,
	"./icra24yokohama.jpeg": 251,
	"./icra25allanwang.jpeg": 252,
	"./icra25atlanta.jpeg": 253,
	"./icra25vovapresentation.jpeg": 254,
	"./icra25workshop.jpeg": 255,
	"./icra26haroldspeech.jpeg": 256,
	"./nusclearlabjiaming.jpeg": 257,
	"./nusclearlabjiaming2.jpeg": 258,
	"./openssidaynus.jpeg": 259,
	"./openssidaynusharoldphotobom.jpeg": 260,
	"./openssidaypreparations.jpeg": 261,
	"./presentingatrobosg.jpeg": 262,
	"./robosg.jpeg": 263,
	"./robosgdemo.jpeg": 264,
	"./robosgdemo2.jpeg": 265,
	"./robosgdemonstration.jpeg": 266,
	"./rss24group.jpeg": 267,
	"./rss24grouppic.jpeg": 268,
	"./rss25speech.jpeg": 269,
	"./rss25withvovaandfriends.jpeg": 270,
	"./ssidemoday.jpeg": 271,
	"./tubteam.jpeg": 272,
	"./tubteam2.jpeg": 273,
	"./tubteam3.jpeg": 274,
	"./withgoodfriendsofNUS.jpeg": 275,
	"./withsamsonbuddy.jpeg": 276,
	"./workshoporganizersicra25.jpeg": 277
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 237;